import { useSelector } from 'hooks';
import { RecoilRoot } from 'recoil';

import { Grid } from '@mui/material';

import BulkApproveDuties from './components/BulkApproveDuties';
import DutyLineSummaryGrid from './components/DutyLineSummaryGrid';
import PeriodSelector from './components/PeriodSelector';
import RealizationProcedure from './components/RealizationProcedure';
import RecalculateDuties from './components/RecalculateDuties';

const Realization = () => {
  const { hasRealizationAccess } = useSelector(({ grants }) => grants);

  return (
    <>
      <PeriodSelector />
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <RecalculateDuties />
        </Grid>
        <Grid item xs={4}>
          <RealizationProcedure />
        </Grid>
        {hasRealizationAccess && (
          <Grid item xs={4}>
            <BulkApproveDuties />
          </Grid>
        )}
      </Grid>
      <DutyLineSummaryGrid />
    </>
  );
};

const RealizationContainer = (props) => {
  return (
    <RecoilRoot>
      <Realization {...props} />
    </RecoilRoot>
  );
};

export default RealizationContainer;
